export default {
    apiKey: "AIzaSyDNe_Wwetlfu4oHi3M4pP_NCBOXiSQVfeQ",
    authDomain: "fmp20-260516.firebaseapp.com",
    databaseURL: "https://fmp20-260516.firebaseio.com",
    projectId: "fmp20-260516",
    storageBucket: "fmp20-260516.appspot.com",
    messagingSenderId: "470735552943",
    appId: "1:470735552943:web:a7534e1871bff0b0d02f5a",
    measurementId: "G-CFP61ZMPZ8"
}